import React from 'react'
import { Text } from 'roadie-ui'
import { LocalizedRichText, LocalizedText } from 'localization'

type ScorecardBand = 'acceptable' | 'coaching' | 'abuser'

const returnRateTexts: Record<ScorecardBand, React.ReactNode> = {
  acceptable: (
    <>
      <Text.Body2 $color="neutral-black">
        <LocalizedText translationKey="dweb_return_rate_message_acceptable" />
      </Text.Body2>
      <br />
      <Text.Body2 $color="neutral-black">
        <LocalizedText translationKey="dweb_dashboard_return_rate_message_keep_up_great_work_by_sticking_same_practices" />
      </Text.Body2>
      <br />
    </>
  ),
  coaching: (
    <>
      <Text.Body2 $color="neutral-black">
        <LocalizedText translationKey="dweb_dashboard_return_rate_message_return_rate_higher_than_most_other_drivers_who" />
      </Text.Body2>
      <br />
      <Text.Body2 $color="neutral-black">
        <LocalizedText translationKey="dweb_return_rate_message_unnecessary_returns_risk" />
      </Text.Body2>
      <br />
      <Text.Caption>
        <LocalizedText translationKey="dweb_return_rate_message_high_rate_risk" />
      </Text.Caption>
    </>
  ),
  abuser: (
    <>
      <Text.Body2 $color="neutral-black">
        <LocalizedRichText
          translationKey="dweb_return_rate_message_high_rate_cta"
          params={{
            strongText1: (
              <strong>
                <LocalizedText translationKey="dweb_return_rate_improve_to_avoid_deactivation" />
              </strong>
            ),
          }}
        />
      </Text.Body2>
      <br />
      <Text.Body2 $color="neutral-black">
        <LocalizedText translationKey="dweb_return_rate_message_unnecessary_returns_risk" />
      </Text.Body2>
      <br />
      <Text.Caption>
        <LocalizedText translationKey="dweb_return_rate_message_high_rate_risk" />
      </Text.Caption>
    </>
  ),
}

type ReturnRateMessageProps = {
  scorecardBand: string
}

export const ReturnRateMessage: React.FC<ReturnRateMessageProps> = ({ scorecardBand }) => {
  // Ensure scorecardBand is one that we support
  if (scorecardBand === 'acceptable' || scorecardBand === 'coaching' || scorecardBand === 'abuser') {
    return <>{returnRateTexts[scorecardBand]}</>
  }
  // Fallback for unexpected values
  return null
}
